<main class="d-flex justify-content-center py-5">
    <div class="glass-card w3-animate-top">
        <h1 class="w3-jumbo w3-center text-danger">🚫 Access Denied</h1>
        <hr class="w3-border-red" style="margin:auto; width:60%; margin-bottom: 20px;">
        <h3 class="w3-center w3-animate-right">You don't have permission to view this page</h3>
        <h6 class="w3-center w3-animate-zoom error-code">Error Code: <strong>403 Forbidden</strong></h6>
        <div class="w3-center" style="margin-top: 20px;">
            <a href="/" class="home-btn w3-animate-bottom">⬅ Back to Home</a>
        </div>
    </div>
</main>